import "./adminDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";

interface AdminDetailsViewComponentProps {
    facilityAdminDetails: any;
    onEditModeOpen: any;
    canEdit: boolean;
}

const AdminDetailsViewComponent = (props: AdminDetailsViewComponentProps) => {
    const {facilityAdminDetails, onEditModeOpen,canEdit} = props;

    return (
        <div className={'admin-details-view-component details-tab-data-content'}>
            {facilityAdminDetails && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Basic Details</div>
                    <div className="">
                        {
                            canEdit &&
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        }
                    </div>
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"NPI Number"}> {facilityAdminDetails.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Middle Name"}> {facilityAdminDetails.middleName || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"First Name"}> {facilityAdminDetails.firstName || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Last Name"}> {facilityAdminDetails.lastName || 'N/A'} </DetailsDataKeyValueComponent>

                        </Grid>
                    </Grid>
                </div>
                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Contact Details</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Email ID"}> {facilityAdminDetails.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Fax Number"}> {CommonService.getMaskedMobileNumber(facilityAdminDetails?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(facilityAdminDetails.mobileNumber)|| 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>

                        </Grid>
                    </div>
                </>
                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Address Details</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 1"}> {facilityAdminDetails.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 2"}> {facilityAdminDetails.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"State"}> {facilityAdminDetails.state || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"ZIP Code"}> {facilityAdminDetails.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"City"}> {facilityAdminDetails.city || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                </>

            </>}
        </div>
    );

};

export default AdminDetailsViewComponent;
